import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { CartProvider } from "./pages/CartContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { requestNotificationPermission } from "./firebase"; // Ensure this path points correctly to your firebase configuration
import UserSearch from "./pages/UserSearch";
import BoulangerieItems from "./pages/BoulangerieItems";
import Cart from "./pages/Cart";
import Payment from "./pages/Payment";
import AddItems from "./pages/Restaurant/AddItems";
import OwnerLoginForm from "./pages/OwnerLoginForm";
import OwnerSignUpForm from "./pages/OwnerSignUpForm";
import TokenDetails from "./pages/TokenDetails";
import OwnerOrders from "./pages/Restaurant/OwnerOrders";
import UserLogin from "./pages/UserPages/UserLogin";
import UserSignup from "./pages/UserPages/UserSignUp";
import BurgerSelection from "./pages/BurgerSelection";
import "./App.css"
import VoiceOrder from "./pages/VoiceOrder";
import AddMenuForm from "./pages/AddMenuForm";
import RestaurantMenu from "./pages/RestaurantMenu";
import SuccessPage from "./pages/SuccessPage";
import CardDetails from "./pages/CardDetails";
import AddCategoryAndItems from "./pages/AddCategoryAndItems";
import InstallPrompt from './InstallPrompt';
import PrintOrderButton from './pages/PrintOrderButton';


// Load your Stripe public key pk_live_51Qhe4xFYsQpDHoxcxUh68hFGvCbAsebVPMsFmbCI5sZwODBIEjZUWAfCQhgHeQD4OfCdPSVLXb0T4iqGCkBuOSbi0075l0NgDf
//test: pk_test_51Qhe4xFYsQpDHoxcoyKC3uAYxD0UYXjrniJTfEtPubNKnLv5PGwSvdYZRmllMeRRnDWyj2REL6DoI5P6WbVNeWU500IJ5547pt
const stripePromise = loadStripe(
  "pk_test_51Qhe4xFYsQpDHoxcoyKC3uAYxD0UYXjrniJTfEtPubNKnLv5PGwSvdYZRmllMeRRnDWyj2REL6DoI5P6WbVNeWU500IJ5547pt"
);

const App = () => {
  // useEffect(() => {
  //   // Request notification permission
  //   requestNotificationPermission();
  // }, []);

  return (
    
    <CartProvider>
      
      <Elements stripe={stripePromise}>
        
        <Router>
        <InstallPrompt />
        <h1>Welcome to My PWA!</h1>
          <Routes>
         
                <Route index element={<UserLogin />} />
                <Route path="/boulangerie/:ownerId" element={<BoulangerieItems />} />
                <Route path="/restaurant/:ownerId" element={<RestaurantMenu />} />

                <Route path="/cart" element={<Cart />} />
                <Route path="/userSearch" element={<UserSearch />} />
                <Route path="/payment" element={<Payment />} />
                <Route path="/card-details" element={<CardDetails />} />

                <Route path="/success" element={<SuccessPage />} />

                <Route path="/tokenDetails/:token" element={<TokenDetails />} />
                <Route path="/ownersignupform" element={<OwnerSignUpForm />} />
                <Route path="/ownerloginform" element={<OwnerLoginForm />} />
                <Route path="/usersignup" element={<UserSignup />} />
                <Route path="/userlogin" element={<UserLogin />} />
                <Route path="/ownerorders" element={<OwnerOrders />} />
                <Route path="/AddItems" element={<AddItems />} />
                <Route path="/addCategoryAndItems" element={<AddCategoryAndItems />} />

                
                <Route path="/addmenu" element={<BurgerSelection />} />
                <Route path="/voice" element={<VoiceOrder/>}/>
                <Route path="/addrestmenu" element={<AddMenuForm/>}/>
                <Route path="/printorder" element={<PrintOrderButton/>}/>

            
          </Routes>
        </Router>
      </Elements>
    </CartProvider>
  );
};

// HomePage moved outside
// const HomePage = () => {
//   return (
//       <div className="home-container">
//           {/* Hero Section */}
//           <section className="hero">
//               <div className="hero-content">
//                   <h1>Delicious Food, Delivered Fast</h1>
//               </div>
//           </section>

//           {/* Navigation Links Section */}
//           <section className="navigation-links">
//               <div className="container">
//                   <nav className="home-navigation">
//                   {/* <Link to="/voice" className="home-nav-link">
//                           Voice Order 
//                       </Link>
//                       <Link to="/addrestmenu" className="home-nav-link">
//                           ADD REST MENU
//                       </Link>
//                   <Link to="/userSearch" className="home-nav-link">
//                           Order Now 
//                       </Link> */}
//                       <Link to="/usersignup" className="home-nav-link">
//                           User Sign Up
//                       </Link>
//                       <Link to="/userlogin" className="home-nav-link">
//                           User Login
//                       </Link>
//                       <Link to="/ownersignupform" className="home-nav-link">
//                           Add Restaurant
//                       </Link>
//                       <Link to="/ownerloginform" className="home-nav-link">
//                           Owner Login
//                       </Link>
//                   </nav>
//               </div>
//           </section>

//       </div>
//   );
// };

export default App;